import React from "react";
import {
  Select,
  MenuItem,
  SelectProps,
  InputLabel,
  FormControl,
} from "@mui/material";

type CustomerSelectProps = {
  isError?: boolean;
  isLoading?: boolean;
  isEmpty?: boolean;
  inputLabel: string;
} & SelectProps;

const CustomerSelect = React.forwardRef<HTMLDivElement, CustomerSelectProps>(
  (
    {
      isError = false,
      isLoading = false,
      isEmpty = false,
      inputLabel,
      children,
      ...props
    },
    ref
  ) => {
    return (
      <FormControl sx={{ m: 1, minWidth: "100%", margin: 0 }} required={true}>
        <InputLabel
          id={`${inputLabel}-label`}
          sx={{
            marginLeft: "-14px",
          }}
        >
          {inputLabel}
        </InputLabel>
        <Select
          {...props}
          ref={ref} // 将 ref 转发到 Select 组件
          displayEmpty
          label={inputLabel}
          data-testid={"customer-select"}
          MenuProps={{ PaperProps: { sx: { maxHeight: "25%" } } }}
        >
          {isLoading ? (
            <MenuItem value="" key="loading" disabled>
              Loading...
            </MenuItem>
          ) : isError ? (
            <MenuItem value="" key="error" disabled>
              Oops! We encountered a problem. Please try again
            </MenuItem>
          ) : isEmpty ? (
            <MenuItem value="" key="noOption" disabled>
              No Option(Refer guidelines)
            </MenuItem>
          ) : (
            children
          )}
        </Select>
      </FormControl>
    );
  }
);

CustomerSelect.displayName = "CustomerSelect";
export default CustomerSelect;
